import React from 'react';

import { Box } from '../../../Box';
import { Typography } from '../../../Typography';
import { Icon } from '../../../Icon';

interface ImageFailedProps {
  height?: string;
  width?: string;
  variant: 'one' | 'many';
}

export const ImageFailed = ({
  height = '536px',
  width = '100%',
  variant,
}: ImageFailedProps) => {
  return (
    <Box
      bgcolor="bg.greyscale.primary"
      height={height}
      width={width}
      maxWidth="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="8"
      radius="s"
    >
      <Box
        radius="round"
        bgcolor="bg.greyscale.tertirary"
        width="44px"
        height="44px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon
          name="picture_slash_outline"
          size="20"
          color="text.light.tertirary"
        />
      </Box>
      <Typography variant="subtitle1" color="text.light.primary">
        {variant === 'many'
          ? 'Не удалось загрузить изображения'
          : 'Не удалось загрузить изображение'}
      </Typography>
      <Typography variant="body3" color="text.light.tertirary">
        Попробуйте обновить страницу
      </Typography>
    </Box>
  );
};
